import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterAccueilActivePictoProps extends pictoProps {
}

export interface FooterAccueilActivePictoState extends pictoState {
}

export class FooterAccueilActivePicto extends Picto<FooterAccueilActivePictoProps,FooterAccueilActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerAccueilActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterAccueilActivePicto);
